<template>
  <div class="data-analysis-pad">
    <template v-if="!isShowDetail">
      <div class="data-picker-wrapper">
        <div class="date-picker">
          <div class="picker-item">
            <div class="key">
              测风开始时间
            </div>
            <div class="sim-input">{{ originStartDate }}</div>
          </div>
          <div class="picker-item">
            <div class="key">
              测风结束时间
            </div>
            <div class="sim-input">{{ originEndData }}</div>
          </div>
        </div>
        <div class="date-picker">
          <div class="picker-item">
            <div class="key">
              代表年开始时间
            </div>
            <div>
              <el-date-picker
                v-model="dateRange[0]"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="选择开始日期"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- <div class="bar"></div> -->

          <div class="picker-item">
            <div class="key">
              代表年结束时间
            </div>
            <div>
              <el-date-picker
                v-model="dateRange[1]"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="选择结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="btn-wrapper">
            <ct-button
              v-if="isOwnerFlag == 0 || isOriginalFlag == 1"
              :btn-click="handleSureClick"
              type="primary"
              >查询
            </ct-button>
            <ct-button
              v-if="isOwnerFlag == 1 && isOriginalFlag == 0"
              :btn-click="handleSaveClick"
              type="primary"
              >保存</ct-button
            >
          </div>
        </div>
      </div>
      <div class="echarts-content" v-if="isShowChart">
        <CustomeChart :types="types" @detailClick="handleDetailClick" />
      </div>
      <div v-else class="echarts-desc">
        请选择时间范围
      </div>
    </template>

    <template v-else>
      <div>
        <div class="active-name">
          {{ activeChannelName }}
        </div>
        <hot-table
          tableClassName="my-hot-table-class intergity"
          licenseKey="non-commercial-and-evaluation"
          height="450px"
          :colHeaders="colHeaders"
          :rowHeaders="rowHeaders"
          :data="data"
          :colWidths="30"
          :manualRowResize="false"
          :manualColumnResize="false"
          :contextMenu="false"
          :readOnly="true"
          :stretchH="'all'"
          :autoColumnSize="true"
          :rowHeaderWidth="70"
          :disableVisualSelection="true"
          key="non-commercial-and-evaluation"
          :renderer="renderFn"
          selectionMode="single"
        ></hot-table>
      </div>
      <div class="btn_back">
        <ct-button :btn-click="handleBackClick">返回</ct-button>
      </div>
    </template>
  </div>
</template>
<script>
import { HotTable } from '@handsontable/vue';
import CustomeChart from '../components/custome-chart';
import { mapState } from 'vuex';
import { serializer } from '../../../utils';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
export default {
  components: {
    CustomeChart,
    HotTable
  },
  data() {
    return {
      originStartDate: '',
      originEndData: '',
      dateRange: [null, null],
      date: '',
      isShowDetail: false,
      chartOption: {},
      types: [],
      data: [],
      rowHeaders: [],
      colHeaders: [],
      activeChannelName: '',
      colors: [
        '#063772',
        '#054e9f',
        '#0460cc',
        '#1271ed',
        '#356c2c',
        '#57b44d',
        '#f76a6b',
        '#f4459b',
        '#fe8420'
      ].reverse(),
      selectTowerId: '',
      selectVersionId: ''
    };
  },
  created() {
    // this.dateRange = [...this.dateRangeStore];
    // this.handleQueryTimes(this.selectVersionId);
  },
  // watch: {
  //   SelectVersionId: {
  //     handler(val) {
  //       if (val) {
  //         this.handleQueryTimes(val);
  //       }
  //       this.isShowDetail = false;
  //       this.types = [];

  //     }
  //   }
  // },
  watch: {
    towerInfo: {
      handler(newVal, oldValue) {
        if (!isEqual(newVal, oldValue)) {
          this.handleQueryTimes(newVal);
          this.isShowDetail = false;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState('WindData', ['dateRangeStore']),
    isShowChart() {
      return this.dateRange.length > 1;
    },
    isOwnerFlag: function() {
      return this.$store.state.WindData.towerObj.isOwnerFlag;
    },
    isOriginalFlag: function() {
      return this.$store.state.WindData.towerObj.original;
    },
    towerInfo: function() {
      return this.$store.state.WindData.towerObj;
    }
  },
  methods: {
    handleSaveClick() {
      let val = this.dateRange;
      if (!val.length) return;

      if (val && val[0] && val[1]) {
        const startDate = moment(val[0]).format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment(val[1]).format('YYYY-MM-DD HH:mm:ss');
        if (startDate > endDate) {
          return this.$message.warning('开始时间不能晚于结束时间！');
        }

        this.$store.commit('WindData/SET_DATERANGE', [startDate, endDate]);
        this.$fetch({
          url: '/winddata/dataProcess/saveVersionHistoryDataIntegrity',
          method: 'POST',
          module: 'windData',
          showSuccess: true,
          showError: false,
          // showLoading: true,
          data: {
            endTime: this.dateRangeStore[1],
            startTime: this.dateRangeStore[0],
            towerId: this.selectTowerId,
            versionId: this.selectVersionId
          }
        }).then(() => {
          this.handleQueryTimes(this.towerInfo);
        });
      } else {
        if (!val[0]) return this.$message.warning('请选择开始时间');
        if (!val[1]) return this.$message.warning('请选择结束时间');
      }
    },
    handleSureClick() {
      let val = this.dateRange;

      if (!val.length) return;

      if (val && val[0] && val[1]) {
        const startDate = moment(val[0]).format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment(val[1]).format('YYYY-MM-DD HH:mm:ss');
        if (startDate > endDate) {
          return this.$message.warning('开始时间不能晚于结束时间！');
        }

        this.$store.commit('WindData/SET_DATERANGE', [startDate, endDate]);
        this.queryData();
      } else {
        if (!val[0]) return this.$message.warning('请选择开始时间');
        if (!val[1]) return this.$message.warning('请选择结束时间');
      }
    },
    handleQueryTimes(towerInfo) {
      let { towerId, versionId } = towerInfo || {};
      if (!towerId || !versionId) return;
      this.selectTowerId = towerId;
      this.selectVersionId = versionId;
      this.$fetch('/winddata/dataProcess/getTimes', {
        params: {
          versionId,
          towerId
        },
        module: 'windData'
      }).then(res => {
        const { data = {} } = res;
        const { towerVersion = {}, towerOriginalVersion = {} } = data;
        const { startDate, endDate } = towerVersion;
        const {
          startDate: originStartDate,
          endDate: originEndData
        } = towerOriginalVersion;

        this.originStartDate = originStartDate;
        this.originEndData = originEndData;

        this.dateRange = [
          moment(startDate).valueOf(),
          moment(endDate).valueOf()
        ];
        this.handleSureClick();
      });
    },
    handleDetailClick(_item) {
      const { item = {} } = _item;

      const { channelNo, channelName } = item;
      this.activeChannelName = channelName;

      this.$fetch('/winddata/dataProcess/getChannelHistoryDataIntegrity', {
        module: 'windData',
        params: {
          channelNo,
          endTime: this.dateRangeStore[1],
          startTime: this.dateRangeStore[0],
          versionId: this.selectVersionId,
          towerId: this.selectTowerId
        }
      }).then(res => {
        const { data = {} } = res;
        const { dayIntegrityData = [] } = data;

        const arr = new Set(dayIntegrityData.map(i => i.month));
        this.rowHeaders = Array.from(arr);

        this.data = dayIntegrityData.map(i => i.data);
      });

      this.isShowDetail = true;
    },
    queryData() {
      if (this.dateRangeStore[0] && this.dateRangeStore[1]) {
        this.$fetch
          .get(
            '/winddata/dataProcess/getVersionHistoryDataIntegrity' +
              '?' +
              serializer({
                startTime: this.dateRangeStore[0],
                endTime: this.dateRangeStore[1]
              }),
            {
              module: 'windData',
              params: {
                towerId: this.selectTowerId,
                versionId: this.selectVersionId
              },
              showError: true
              // showLoading: true
            }
          )
          .then(res => {
            const { data = {} } = res || {};

            // timeSeq = []
            const { dataList = [] } = data;

            this.types = dataList.map((i, index) => {
              return {
                _start: moment(this.dateRangeStore[0]).valueOf(),
                _end: moment(this.dateRangeStore[1]).valueOf(),
                ...i,
                rate: i.integrityRate,
                _name: i.channelName || '',
                bi: i.point,
                value: i.data.map(aData => ({
                  value: [
                    index,
                    moment(aData[0]).valueOf(),
                    moment(aData[1]).valueOf()
                  ],
                  itemStyle: {
                    normal: {
                      color: this.colors[index % this.colors.length]
                    }
                  }
                }))

                // getIntergrityInterval(i.data, timeSeq, index, {
                //   normal: {
                //     color: this.colors[index % this.colors.length]
                //   }
                // })
              };
            });
          });
      }
    },
    // eslint-disable-next-line
    renderFn(hotInstance, TD, row, col, prop, value, cellProperties) {
      let _value = value;
      if (_value) {
        if (!isNaN(+_value)) {
          if (_value >= 144) {
            TD.style.backgroundColor = '#07c160';
          } else if (_value <= 0) {
            TD.style.backgroundColor = '#ff7875';
          } else {
            TD.style.backgroundColor = '#ffa940';
          }
        } else {
          TD.style.backgroundColor = '';
        }
      } else {
        TD.style.backgroundColor = '';
      }

      TD.innerHTML = _value;
    },
    handleBackClick() {
      this.isShowDetail = false;
    }
  },
  mounted() {
    this.handleQueryTimes(this.towerInfo);
    this.colHeaders = new Array(31).fill(1).map((i, index) => index + 1);
  }
};
</script>
<style lang="less" scoped>
.active-name {
  margin-bottom: 5px;
}
.btn-wrapper {
  margin-left: 10px;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.bar {
  display: inline-block;
  margin: 0px 10px;
}
.echarts-desc {
  height: 200px;
  width: 100%;
  line-height: 200px;
  text-align: center;
}
.data-analysis-pad {
  box-sizing: border-box;
  background-color: rgb(240, 245, 250);
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 12px;
  position: relative;
  box-shadow: 1px 3px 5px 0px rgba(4, 0, 0, 0.1);
  border-radius: 10px;
  .echarts-content {
    height: 500px;
    background: #ffffff;
    font-size: 14px;
    color: #222233;
  }
  .data-picker-wrapper {
    background: #2f6ba44d;
    padding: 13px 20px 13px 10px;
    border-radius: 8px;
    position: relative;
  }
  .date-picker {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .picker-item {
      display: flex;
      align-items: center;
      width: 50%;
      .key {
        font-size: 16px;
        font-weight: bold;
        color: #222233;
        margin-right: 10px;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        text-align: right;
        width: 140px;
      }
      input {
        font-size: 16px;
        color: #222233;
      }
      .sim-input {
        width: 220px;
        margin-right: 20px;
        margin-left: 30px;
        font-size: 14px;
        color: #222233;
      }
    }
  }
  .btn_back {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
</style>

<style lang="less">
#hot-display-license-info {
  display: none !important;
}
.data-analysis-pad {
  .el-date-editor {
    &.el-input {
      width: 180px;
    }
    .el-icon-time {
      display: none;
    }
  }
}
.my-hot-table-class {
  &.intergity {
    thead {
      th {
        background-color: #0076a2;
        color: #fff;
      }
    }
    tbody {
      text-align: center;
      color: #fff;
    }
  }
}
.picker-item {
  /deep/ .el-date-editor {
    input {
      font-size: 14px;
      color: #222233;
    }
  }
}
</style>
